import React from "react";
import styles from "./Frame.module.scss";

export default function Frame({
  children,
  padding = 24,
  noframe = false,
  editButton,
  ...props
}) {
  return noframe ? (
    children
  ) : (
    <section className={styles.frame} style={{ padding }} {...props}>
      {editButton && <div className={styles.editButton}>{editButton}</div>}
      <section>{children}</section>
    </section>
  );
}
